import {
  type HttpClientError,
  type HttpClientConfig,
  type HttpClientInterface,
} from 'core/infra/http/HttpClient'

import { type BidProbability } from '../domain/BidProbability'

type BidProbabilityRepositoryDependencies = {
  httpClient: HttpClientInterface
}

export class BidProbabilityRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: BidProbabilityRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getBidProbabilitiesByOfferUUID(
    offerUUID: string,
    config?: Partial<HttpClientConfig>
  ): Promise<Array<BidProbability> | undefined> {
    const endpoint = `/api/v2/loadboard/bid_probabilities/${offerUUID}`

    try {
      const {
        data: { probabilities },
      } = await this.httpClient.get<{ probabilities: Array<BidProbability> }>(endpoint, {
        ...config,
      })

      return probabilities
    } catch (error) {
      if ((error as HttpClientError<BidProbability>)?.response?.status === 404) {
        return undefined
      }

      throw new Error('Failed to get bid probabilities', { cause: error as Error })
    }
  }
}
